import GroupsUserlist from './GroupsUserlist';

export default GroupsUserlist;
